import { Button, FormContext, FormDatePicker, FormItem, FormSubmitButton, FormTextArea, MasterDetailForm, Widget, notification } from '@digital/ui';
import { Row, Col, Checkbox, Modal, Icon } from 'antd';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import ModalAvancar from './ModalAvancar';
import ModalAprovacaoProponentes from './ModalAprovacaoProponentes';
import ModalRetornarFluxoProponentes from './ModalRetornarFluxoProponentes';
import { stepState, anteriorStepState, ordemCompraIdState, showModalDesobrigarConfideIdState, dadosGeraisState, reloadVendorListState, reloadWidgetTimelineState, reloadState, ordemCompraRodadaNegociacaoIdState, ajustarStepOnReloadState, reloadDadosGeraisState, dataLimiteEtapaState } from '../atoms';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { Space, Visibility } from '@app/components';
import { ButtonModalEnviarConsolidacaoparaArea } from './ButtonModalEnviarConsolidacaoparaArea';
import { enviarEmailsRespostaConsolidacaoEsclarecimentos, getPropostasOrdemCompra, ISasPropostaOrdemCompra, notificarDemandanteCadastroNovaRodada, verificarNecessidadeCadastroNovaRodada } from '@app/api/sas/sasProposta';
import { ButtonModalEnviarPropostaTecnica } from './ButtonModalEnviarPropostaTecnica';
import { ButtonModalAtivarNegociacaoMinuta } from './ButtonModalAtivarNegociacaoMinuta';
import { baixarProponentesSemConfide, getIsAjusteOrcamentario } from '@app/api/sas/ordemCompra';
import { ButtonModalDefinirVencedor } from './ButtonModalDefinirVencedor';
import { ModalAprovarCES } from '../WidgetAcompanhamentoProcesso/ModalAprovarCES';
import { isValidGuid } from '@app/helpers/geradorGuid';
import ModalEnvioCartaConvite from '../WidgetAcompanhamentoProcesso/ModalEnvioCartaConvite';
import ModalConfirmarHandover from '../WidgetDocumentacao/ModalConfirmarHandover';
import ModalGerarContratoTotvs from '../AbaRelatorioHomologacao/ModalGerarContratoTotvs';
import { enviarParaAprovacao } from '@app/api/sas/relatorioHomologacao';
import ButtonModalEnviarDdi from './ButtonModalEnviarDdi';
import ButtonModalEnvioCartaAgradecimento from './ButtonModalEnvioCartaAgradecimento';
import ModalEmitirContrato from './ModalEmitirContrato';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalNotificarVencedorAreaTecnica from '../WidgetAcompanhamentoProcesso/ModalNotificarVencedorAreaTecnica';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import ModalEmitirPCS from './ModalEmitirPCS';
import { parametrosSasState } from '@app/atoms';
import AjusteOrcamentario from '../AjusteOrcamentario';
import { EStatusAprovacaoContratoTotvs } from '@app/enums';
import ButtonModalDesobrigarDdi from './ButtonModalDesobrigarDdi';
import ModalEnviarCartaEsclarecimentoTecnicoFornecedor from '../WidgetAcompanhamentoProcesso/ModalEnviarCartaEsclarecimentoTecnicoFornecedor';
import ModalEnviarCartaPropostaTecnicaFornecedor from '../WidgetAcompanhamentoProcesso/ModalEnviarCartaPropostaTecnicaFornecedor';
import ButtonSolicitarRespostaVisitaTecnica from '../WidgetAcompanhamentoProcesso/ButtonSolicitarRespostaVisitaTecnica';
import { ButtonIniciarPropostaComercial } from './ButtonIniciarPropostaComercial';
import { ButtonModalAtivarDemanda } from './ButtonModalAtivarDemanda';

interface Props {
}

const WidgetActions = (props: Props) => {
  const [step, setStep] = useRecoilState(stepState);
  const anteriorStep = useRecoilValue(anteriorStepState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
  const showDesobrigarId = useRecoilValue(showModalDesobrigarConfideIdState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const setOrdemCompraRodadaNegociacaoId = useSetRecoilState(ordemCompraRodadaNegociacaoIdState);
  const [exibirModalAprovacaoProponentes, setExibirModalAprovacaoProponentes] = useState(false);
  const [exibirModalNovaRodada, setExibirModalNovaRodada] = useState(false);
  const [fornecedoresNovaRodada, setFornecedoresNovaRodada] = useState<ISasPropostaOrdemCompra[]>([]);
  const [exibirModalRetornarFluxoProponentes, setExibirModalRetornarFluxoProponentes] = useState(false);
  const [statusAnterior, setStatusAnterior] = useState('');
  const setAjustarStepOnReload = useSetRecoilState(ajustarStepOnReloadState);
  const ehAditivo = dadosGerais.tipo === ETipoDemanda.Aditivo || dadosGerais.tipo === ETipoDemanda.AditivoFaturamentoDireto;
  const ehFaturamentoDireto = dadosGerais.tipo === ETipoDemanda.FaturamentoDireto;
  const ehAditivoContrato = ehAditivo && dadosGerais.tipoContrato && dadosGerais.tipoContrato.toLowerCase() === "contrato";
  const aditivoComIntegracaoTotvs = dadosGerais.isPrazo || dadosGerais.isValorSemAcrescimoEscopo;
  const tipoContrato = dadosGerais.modalidadeContratoTotvs || dadosGerais.tipoContrato || '';
  const ehPCS = tipoContrato.toLowerCase() === ETipoContrato.PCS;
  const parametrosSas = useRecoilValue(parametrosSasState);
  const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);
  const [disableEnvioAprovacao, setDisableEnvioAprovacao] = useState(false);

  const onReload = () => {
    setReloadWidgetTimeline(!reloadWidgetTimeline);
    setReloadVendorList(!reloadVendorList);
    setReloadDadosGerais(!reloadDadosGerais);
    setReload(!reload);
  };

  const handleBotaoVoltar = () => {
    setOrdemCompraRodadaNegociacaoId(anteriorStep.ordemCompraRodadaNegociacaoId);
    setStep({ ...anteriorStep });
  };

  const handleRespostaConsolidacaoEsclarecimentos = () => {
    Modal.confirm({
      title: 'Enviar Resposta de Esclarecimentos',
      icon: <Icon type="info-circle" />,
      content: "Confirme que os esclarecimentos técnicos consolidados antes de enviar para os fornecedor. Deseja enviar as respostas dos esclarecimentos para todos os proponentes?",
      onOk() {
        Modal.confirm({
          title: 'Confirmação Envio de Email',
          content:
            'Você deseja enviar este e-mail?',
          cancelText: 'Não',
          onCancel: () => {
            enviarEmailsRespostaConsolidacaoEsclarecimentos(ordemCompraId, false, step.ordemCompraFluxoProcessoId).then((response: any) => {
              if (response && response.valid) {
                onReload();
              }
            });
          },
          okText: 'Sim',
          onOk: () => {
            enviarEmailsRespostaConsolidacaoEsclarecimentos(ordemCompraId, true,step.ordemCompraFluxoProcessoId).then((response: any) => {
              if (response && response.valid) {
                onReload();
              }
            });
          },
        });
      },
      onCancel() { },
    });
  };

  const handleBaixarProponentesSemConfide = () => {
    baixarProponentesSemConfide(ordemCompraId);
  };

  const handleReloadCadastrarNovaRodada = () => {
    setAjustarStepOnReload(true);
    setReloadDadosGerais(!reloadDadosGerais);
    onReload();
  };

  const handleCadastrarNovaRodada = () => {
    getPropostasOrdemCompra({ ordemCompraId, isAtivas: true }).then((response: any) => {
      setFornecedoresNovaRodada(response || []);
      setExibirModalNovaRodada(true);
    });
  };

  const handleConfirmarNovaRodada = (values: any) => {
    setExibirModalNovaRodada(false);
    Modal.confirm({
      title: 'Enviar email',
      icon: <Icon type="info-circle" />,
      content: 'Deseja enviar email para os fornecedores selecionados?',
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => submeterNovaRodada(values, true),
      onCancel: () => submeterNovaRodada(values, false),
    });
  };

  const submeterNovaRodada = (values: any, enviarEmail: boolean) => {
    verificarNecessidadeCadastroNovaRodada({
      ordemCompraId,
      dataLimite: values.dataLimite,
      fornecedoresSelecionados: values.fornecedoresSelecionados || [],
      justificativaNaoSelecionados: values.justificativaNaoSelecionados,
      enviarEmail,
    })
      .then((response: any) => {
        if (response && response.valid) {
          notification.success('Item cadastrado com sucesso.');
          if (response.mensagem) {
            Modal.confirm({
              title: 'Notificar demandante',
              icon: <Icon type="info-circle" />,
              content: response.mensagem,
              okText: 'Sim',
              onOk: () => {
                notificarDemandanteCadastroNovaRodada(ordemCompraId)
                  .then((response: any) => {
                    if (response && response.valid) {
                      handleReloadCadastrarNovaRodada();
                    }
                  });
              },
              cancelText: 'Não',
              onCancel: () => {
                handleReloadCadastrarNovaRodada();
              },
            });
          } else {
            handleReloadCadastrarNovaRodada();
          }
        }
      });
  };

  const handleEnviarAprovacao = () => {
    enviarParaAprovacao(ordemCompraId).then(data => {
      if (data) {
        onReload();
      }
    });
  };

  return (
    <div style={{ paddingBottom: '64px' }}  >

          {(step && isObjNotEmpty(step) && 'fluxoEtapaId' in step) && (
        <Widget>
          <Row type='flex' justify='end'>
            <Visibility visible={
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes ||
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial ||
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao
            }>
              
              <Visibility visible={!dadosGerais.consultiva && dadosGerais.tipo != ETipoDemanda.AditivoFaturamentoDireto}>
                <AjusteOrcamentario />
                <Space mr={8} />
              </Visibility>
            </Visibility>

            {
              dadosGerais && dadosGerais.tipo == ETipoDemanda.FaturamentoDireto  || dadosGerais && dadosGerais.tipo == ETipoDemanda.AditivoFaturamentoDireto? 
              (<>
              <Visibility visible={
              dadosGerais &&
              'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH} >
              <Button 
                title='Enviar para aprovação'
                disabled={
                  !dadosGerais.necessitaEnviarAprovacao
                }
                className='button-sas-acoes'
                type='primary'
                onClick={handleEnviarAprovacao}
              />
              <Space mr={8} />
            </Visibility>
            </>) :
              (<><Visibility visible={
              dadosGerais &&
              // dadosGerais.relatorioEnviarAprovacao === true &&
              // isObjEmptyOrSpaces(dadosGerais.statusAprovacaoRelatorioHomologacaoSas) &&
              'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH} >
              <Button 
                title='Enviar para aprovação'
                disabled={
                  !dadosGerais.necessitaEnviarAprovacao || 
                  (parametrosSas.sasValorMaximoGerenteGeralHabilitado === false
                    || dadosGerais.valorCalcRH >= parametrosSas.sasValorMaximoGerenteGeral) && 
                  (parametrosSas.sasValorMaximoGerenteDepartamentoHabilitado === false
                    || dadosGerais.valorCalcRH >= parametrosSas.sasValorMaximoGerenteDepartamento)
                }
                className='button-sas-acoes'
                type='primary'
                onClick={handleEnviarAprovacao}
              />
              <Space mr={8} />
            </Visibility>
          </>)

            }
            

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs
              }
            >
              <ModalGerarContratoTotvs ordemCompraId={ordemCompraId} />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs && ehPCS} 
            >
              <ModalEmitirPCS />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioDaCartaConvite &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ModalEnvioCartaConvite />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.VisitaTecnica &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ButtonSolicitarRespostaVisitaTecnica />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EsclarecimentosTecnicosSolicitados &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ModalEnviarCartaEsclarecimentoTecnicoFornecedor />
            </Visibility>
            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoPropostaTecnicasProponentes &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ModalEnviarCartaPropostaTecnicaFornecedor />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ButtonIniciarPropostaComercial />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={dadosGerais &&
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.HandoverContrato &&
                (!ehAditivoContrato || aditivoComIntegracaoTotvs) && !ehPCS}
            >
              <ModalEmitirContrato />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={dadosGerais &&
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.HandoverContrato}
            >
              <ModalConfirmarHandover />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnviaCartaAgradecimento}
            >
              <Visibility
                visible={!ehFaturamentoDireto}
              >
              <ButtonModalEnvioCartaAgradecimento disabled={step.isRealizado || (ehAditivo && ehPCS)} />
              <Space mr={8} />
              </Visibility>
              
              <Visibility
                visible={dadosGerais.tipo === ETipoDemanda.NovaContratacao || (ehAditivo && ehPCS ) || ehFaturamentoDireto}
              >
                <ModalNotificarVencedorAreaTecnica />
                <Space mr={8} />
              </Visibility>
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConclusaoDoProcessoStep}>
              <ModalNotificarVencedorAreaTecnica />
              <Space mr={8} />
            </Visibility>


            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioInformaçõesAdmContratosProvidenciarCES
                // && hasPermissionPerfil([EGuidPerfilAcesso.ResponsavelCES])
              }
            >
              <ModalAprovarCES />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes
                  || step.fluxoEtapaId == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao
                  || isValidGuid(showDesobrigarId))
              }
            >
              <Visibility visible={dadosGerais.consultiva}>
                <ButtonModalAtivarDemanda/>
                <Space mr={8} />
              </Visibility>

              <Button
                title='Cadastrar Nova Rodada'
                type='primary'
                onClick={handleCadastrarNovaRodada}
              />
              <Space mr={8} />

              <Visibility visible={!dadosGerais.consultiva}>
                  <ButtonModalDefinirVencedor />
                  <Space mr={8} />
              </Visibility>
            </Visibility>


            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioPropostaTecnicaAreaRequisitante}
            >
              <ButtonModalEnviarPropostaTecnica />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioNegociacaoMinutaContratual}
            >
              <ButtonModalAtivarNegociacaoMinuta />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes}
            >
              <Button
                title='Enviar Resposta de Esclarecimentos'
                type='primary'
                onClick={() => handleRespostaConsolidacaoEsclarecimentos()}
              />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante}
            >
              <ButtonModalEnviarConsolidacaoparaArea />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoDDI}
            >
              <ButtonModalEnviarDdi />
              <Space mr={8} />
              <ButtonModalDesobrigarDdi />
              <Space mr={8} />
            </Visibility>

            <Visibility visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoCONFIDE}  >
              <Button title='Baixar Proponentes Sem Relatório Financeiro' type='primary' onClick={() => handleBaixarProponentesSemConfide()} />
              <Space mr={8} />
            </Visibility>
             <Visibility visible={step.ordem > 21 && !ehFaturamentoDireto && dadosGerais.tipo != ETipoDemanda.AditivoFaturamentoDireto}>
                <Button
                  disabled={dadosGerais.statusAprovacaoContratoTotvs === EStatusAprovacaoContratoTotvs.APROVADO || dadosGerais.statusAprovacaoContratoTotvs === EStatusAprovacaoContratoTotvs.EMITIDO}
                  className='button-sas-acoes'
                  title='retornar propostas comerciais'
                  type='primary'
                  onClick={() => {
                    setStatusAnterior(step.nome); 
                    setExibirModalRetornarFluxoProponentes(true); 
                  }}
                />
              <Space mr={8}/>
            </Visibility>           
            <Visibility
              visible={
                isObjNotEmpty(anteriorStep)
                && isObjNotEmpty(anteriorStep.fluxoEtapaId)
                && 'fluxoEtapaId' in anteriorStep && isObjNotEmpty(anteriorStep.fluxoEtapaId)
                && step.fluxoEtapaId != EGuidFluxoProcessoEtapa.AnaliseDocumentacao
              }
            >
              <Button
                title='Voltar'
                type='danger'
                onClick={() => handleBotaoVoltar()}
              />
              <Space mr={8} />
            </Visibility>
            <ModalAvancar
              setExibirModalAprovacaoProponentes={setExibirModalAprovacaoProponentes}
            />
          </Row>
        </Widget>
      )}

      <ModalAprovacaoProponentes exibirModal={exibirModalAprovacaoProponentes} setExibirModal={setExibirModalAprovacaoProponentes} />
      <ModalRetornarFluxoProponentes
        exibirModal={exibirModalRetornarFluxoProponentes}
        setExibirModal={setExibirModalRetornarFluxoProponentes}
        statusAnterior={statusAnterior}
        setStatusAnterior={setStatusAnterior}
      />

      <Visibility visible={exibirModalNovaRodada}>
        <Modal
          title="Cadastrar Nova Rodada"
          width="680px"
          visible={exibirModalNovaRodada}
          onCancel={() => setExibirModalNovaRodada(false)}
          footer={null}
        >
          <MasterDetailForm
            initialValues={{ dataLimite: undefined, fornecedoresSelecionados: [], justificativaNaoSelecionados: '' }}
            validationSchema={Yup.object().shape({
              dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
              fornecedoresSelecionados: Yup.array().min(1, 'Selecione ao menos 1 fornecedor'),
              justificativaNaoSelecionados: Yup.string().when('fornecedoresSelecionados', {
                is: (selecionados: string[]) => selecionados && selecionados.length < fornecedoresNovaRodada.length,
                then: Yup.string().required('Justificativa é obrigatória para fornecedores não selecionados'),
              }),
            })}
            actions={[
              <Button key="cancelarBtn" type="link" onClick={() => setExibirModalNovaRodada(false)}>
                Cancelar
              </Button>,
              <FormSubmitButton key="confirmarBtn" title="Cadastrar" noIcon type="primary" onClick={handleConfirmarNovaRodada} />,
            ]}
          >
            <Widget>
              <Row>
                <FormDatePicker
                  label="Data Limite de Resposta"
                  name="dataLimite"
                  format="DD/MM/YYYY"
                  span={4}
                  disabledDate={function(current) {
                    if (!dataLimiteEtapa) return false;
                    var limite = new Date(dataLimiteEtapa);
                    limite.setHours(23, 59, 59, 999);
                    return current && current.toDate() > limite;
                  }}
                />
              </Row>
              <FormContext.Consumer>
                {({ formProps }) => (
                  <>
                    <Row style={{ marginTop: 16 }}>
                      <Col span={24}>
                        <FormItem name="fornecedoresSelecionados">
                          <strong>Fornecedores</strong>
                          <div style={{ marginTop: 8 }}>
                            {fornecedoresNovaRodada.map(f => (
                              <Row key={f.id} style={{ marginBottom: 4 }}>
                                <Checkbox
                                  checked={formProps && formProps.values.fornecedoresSelecionados && formProps.values.fornecedoresSelecionados.includes(f.id)}
                                  onChange={e => {
                                    if (!formProps) return;
                                    const current: string[] = formProps.values.fornecedoresSelecionados || [];
                                    if (e.target.checked) {
                                      formProps.setFieldValue('fornecedoresSelecionados', [...current, f.id]);
                                    } else {
                                      formProps.setFieldValue('fornecedoresSelecionados', current.filter((id: string) => id !== f.id));
                                    }
                                  }}
                                >
                                  {f.sasFornecedor ? f.sasFornecedor.razaoSocial : f.sasFornecedorOcNome}{f.sasFornecedor ? ` — ${f.sasFornecedor.email}` : ''}
                                </Checkbox>
                              </Row>
                            ))}
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                    {formProps && formProps.values.fornecedoresSelecionados &&
                      formProps.values.fornecedoresSelecionados.length < fornecedoresNovaRodada.length && (
                      <Row style={{ marginTop: 8 }}>
                        <FormTextArea
                          label="Justificativa para fornecedores não selecionados"
                          name="justificativaNaoSelecionados"
                          span={12}
                          rows={3}
                          required
                        />
                      </Row>
                    )}
                  </>
                )}
              </FormContext.Consumer>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>


    </div>
  );
};

export default WidgetActions;
